/**
 * Fallback UI shown by Sentry.ErrorBoundary when a render exception
 * escapes the React tree.
 *
 * Visual language is intentionally minimal — matches the empty-state
 * pattern from `designs/screens-tourism.jsx` StatesBoard (centered
 * text + a single recovery action).
 */

type Props = {
  resetError: () => void
}

export function ErrorFallback({ resetError }: Props) {
  return (
    <main
      role="alert"
      className="min-h-screen bg-bg-app text-ink-1 font-sans flex flex-col items-center justify-center gap-4 px-6 text-center"
    >
      <h1 className="text-2xl font-medium">Something went wrong</h1>
      <p className="text-ink-3 max-w-md">
        We couldn&apos;t render this view. The error has been reported.
        Reloading the page usually fixes it.
      </p>
      <button
        type="button"
        onClick={() => {
          resetError()
          window.location.reload()
        }}
        className="rounded-md border border-line-2 bg-white px-4 py-2 text-sm font-medium text-ink-1 hover:bg-bg-soft"
      >
        Reload
      </button>
    </main>
  )
}
